import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import Spinner from '@xkit/spinner';

/** @jsx jsx */
var _ref = {
  name: "gyp8mm",
  styles: "visibility:hidden;"
};
var _ref2 = {
  name: "1gx2944",
  styles: "position:absolute;display:flex;top:0;left:0;width:100%;height:100%;align-items:center;justify-content:center;"
};

var Loading = function Loading(_ref3) {
  var children = _ref3.children;
  return jsx(Fragment, null, jsx("span", {
    css: _ref
  }, children), jsx("span", {
    css: _ref2
  }, jsx(Spinner, {
    styles: {
      size: 12,
      width: 2,
      primaryColor: 'rgba(0, 0, 0, 0)'
    }
  })));
};

var defaultStyles = {
  base: {
    position: 'relative',
    display: 'inline-flex',
    appearance: 'none !important',
    textDecoration: 'none',
    padding: '12px 20px',
    borderRadius: 6,
    fontSize: 14,
    lineHeight: 1,
    borderWidth: 1,
    borderStyle: 'solid',
    cursor: 'pointer',
    fontWeight: '600',
    userSelect: 'none',
    outline: 0
  },
  baseHover: {},
  default: {
    color: '#212529',
    backgroundColor: '#ffffff',
    borderColor: '#cccccc'
  },
  defaultsuccess: {
    color: '#00c853'
  },
  defaultwarning: {
    color: '#ee9913'
  },
  defaultdanger: {
    color: '#ec4c47'
  },
  primary: {
    color: '#fff',
    borderColor: '#5e72e4',
    backgroundColor: '#5e72e4'
  },
  primarysuccess: {
    borderColor: '#00c853',
    backgroundColor: '#00c853'
  },
  primarywarning: {
    borderColor: '#ee9913',
    backgroundColor: '#ee9913'
  },
  primarydanger: {
    borderColor: '#ec4c47',
    backgroundColor: '#ec4c47'
  },
  minimal: {
    borderColor: '#fff'
  },
  minimalsuccess: {
    color: '#00c853'
  },
  minimalwarning: {
    color: '#ee9913'
  },
  minimaldanger: {
    color: '#ec4c47'
  },
  block: {
    display: 'block',
    width: '100%'
  },
  disabled: {
    opacity: 0.4,
    cursor: 'not-allowed'
  }
};
var makeStyles = function makeStyles(_ref) {
  var customStyles = _ref.styles,
      appearance = _ref.appearance,
      intent = _ref.intent,
      block = _ref.block,
      disabled = _ref.disabled,
      loading = _ref.loading;
  var styles = [_extends({}, defaultStyles.base, customStyles.base), _extends({}, defaultStyles[appearance], customStyles[appearance]), _extends({}, defaultStyles["" + appearance + intent], customStyles["" + appearance + intent]), block && _extends({}, defaultStyles.block, customStyles.block), disabled && !loading && _extends({}, defaultStyles.disabled, customStyles.disabled), {
    '&:hover': _extends({}, defaultStyles.baseHover, customStyles.baseHover)
  }];
  return styles;
};

var Button = function Button(_ref) {
  var children = _ref.children,
      component = _ref.component,
      appearance = _ref.appearance,
      intent = _ref.intent,
      block = _ref.block,
      disabled = _ref.disabled,
      loading = _ref.loading,
      styles = _ref.styles,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "component", "appearance", "intent", "block", "disabled", "loading", "styles"]);

  var buttonStyles = makeStyles({
    styles: styles,
    appearance: appearance,
    intent: intent,
    block: block,
    disabled: disabled,
    loading: loading
  });

  var buttonProps = _extends({}, props, {
    css: buttonStyles,
    disabled: disabled || loading
  });

  return jsx(component, buttonProps, loading ? jsx(Loading, null, children) : children);
};

Button.defaultProps = {
  block: false,
  loading: false,
  disabled: false,
  appearance: 'default',
  intent: 'none',
  component: 'button',
  type: 'button',
  styles: {}
};

export default Button;
